import { withJsonFormsControlProps } from '@jsonforms/react';
import type { ControlProps } from '@jsonforms/core';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

function DateControlComponent({
  data,
  handleChange,
  path,
  label,
  enabled,
  visible,
  required,
  errors,
  uischema,
}: ControlProps) {
  if (!visible) return null;

  const dateFormat =
    (uischema?.options?.dateFormat as string) || 'MM/DD/YYYY';
  const value = data ? dayjs(data) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={value}
        disabled={!enabled}
        format={dateFormat}
        slotProps={{
          textField: {
            fullWidth: true,
            size: 'small',
            required,
            error: !!errors,
            helperText: errors,
          },
        }}
        onChange={(newValue) => {
          // Store as ISO date string (YYYY-MM-DD)
          handleChange(
            path,
            newValue?.isValid() ? newValue.format('YYYY-MM-DD') : undefined,
          );
        }}
      />
    </LocalizationProvider>
  );
}

export const DateControl = withJsonFormsControlProps(DateControlComponent);
